<template>
  <div>
    <b-row v-if="phase_type === '1p'">
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/volt.svg"
            />
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <div>
              <span style="font-size: 20px; font-weight: 600;">Volt</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="0"
            y="65"
            width="100%"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <center>
              <b> {{ volt }} V</b>
              <!-- <strong style="font-size: 20px;">V</strong> -->
            </center>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/amp.svg"
            />
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <div>
              <span style="font-size: 20px; font-weight: 600;">Amp</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="0"
            y="65"
            width="100%"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <center>
              <b> {{ amp }} A</b>
              <!-- <strong style="font-size: 20px;">A</strong> -->
            </center>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row v-if="phase_type === '3p'">
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/volt.svg"
            />
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <div>
              <span style="font-size: 20px; font-weight: 600;">Volt</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="0"
            y="65"
            width="100%"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <center>
              <b title="Phase1"> {{ volt }} V</b>&nbsp;
              <b title="Phase2"> {{ volt2 }} V</b>&nbsp;
              <b title="Phase3"> {{ volt3 }} V</b>
              <!-- <strong style="font-size: 20px;">V</strong> -->
            </center>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 155.974L24.1932 177.5H680.168H738.5V166.992V155.948V91.8899V32.6916V21.5843L714.81 0.5H0.5V11.4839V22.9677V155.974Z"
            stroke="#00B058"
          />
          <path
            d="M54 178H24.6821L2 157.816V135"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 21.7143V44"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="15"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/amp.svg"
            />
          </foreignObject>
          <foreignObject
            x="50"
            y="17"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <div>
              <span style="font-size: 20px; font-weight: 600;">Amp</span>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="0"
            y="65"
            width="100%"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <center>
              <b title="Phase1"> {{ amp }} A</b>&nbsp;
              <b title="Phase2"> {{ amp2 }} A</b>&nbsp;
              <b title="Phase3"> {{ amp3 }} A</b>
              <!-- <strong style="font-size: 20px;">A</strong> -->
            </center>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      phase_type: '',
      volt: '',
      volt2: '',
      volt3: '',
      amp: '',
      amp2: '',
      amp3: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getValue()
    this.interval = setInterval(() => {
      this.getValue()
    }, 300000)
  },
  mounted() {
    // this.getbarChartCounting()
  },
  methods: {
    getValue() {
      axios.post('/valueLightingDetail', { wid: this.$route.query.wid })
        .then(response => {
          console.log(response.data)
          this.phase_type = response.data[0].phase_type
          this.volt = response.data[0].volt
          this.volt2 = response.data[0].volt2
          this.volt3 = response.data[0].volt3
          this.amp = response.data[0].amp
          this.amp2 = response.data[0].amp2
          this.amp3 = response.data[0].amp3
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  </style>
